// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dRnu","content":"styles_content__1lLLw"};